"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snippet = Snippet;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _utils = require("instantsearch.js/cjs/lib/utils");

var _react = _interopRequireDefault(require("react"));

var _Snippet = require("../ui/Snippet");

var _excluded = ["hit", "attribute", "highlightedTagName", "nonHighlightedTagName", "separator"];

function Snippet(_ref) {
  var hit = _ref.hit,
      attribute = _ref.attribute,
      highlightedTagName = _ref.highlightedTagName,
      nonHighlightedTagName = _ref.nonHighlightedTagName,
      separator = _ref.separator,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var property = (0, _utils.getPropertyByPath)(hit._snippetResult, attribute) || [];
  var properties = Array.isArray(property) ? property : [property];
  var parts = properties.map(function (singleValue) {
    return (0, _utils.getHighlightedParts)((0, _utils.unescape)(singleValue.value || ''));
  });
  return /*#__PURE__*/_react.default.createElement(_Snippet.Snippet, (0, _extends2.default)({}, props, {
    parts: parts,
    highlightedTagName: highlightedTagName,
    nonHighlightedTagName: nonHighlightedTagName,
    separator: separator
  }));
}